export interface DraftMinimumPayload {
  property_type_id?: number | null;
  address_id?: number | null;
}

export interface PublishMeta {
  publish_blockers?: string[] | null;
}

export function validateDraftMinimum(payload: DraftMinimumPayload): string[] {
  const errors: string[] = [];

  if (!payload.property_type_id) {
    errors.push("Tipo de imóvel é obrigatório");
  }

  if (!payload.address_id) {
    errors.push("Endereço é obrigatório");
  }

  return errors;
}

export function getPublishBlockers(meta: PublishMeta): string[] {
  return Array.isArray(meta.publish_blockers) ? meta.publish_blockers : [];
}
